import { render } from "./SelectStudentsForm.vue?vue&type=template&id=027cb2a7&scoped=true"
import script from "./SelectStudentsForm.vue?vue&type=script&lang=js"
export * from "./SelectStudentsForm.vue?vue&type=script&lang=js"

import "./SelectStudentsForm.vue?vue&type=style&index=0&id=027cb2a7&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027cb2a7"]])

export default __exports__